<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.name" placeholder="Search" @change="filterUsers"></el-input>
                </el-form-item>
                <el-form-item align="right">
                    <el-button type="info" size="medium" @click="addUserClick()">+ Add User</el-button>
                </el-form-item>
                <el-form-item align="right">
                    <el-button type="info" size="medium" @click="addExistingUserClick()">+ Add Existing User</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="users" highlight-current-row v-loading="listLoading" style="width: 100%">
            <el-table-column prop="email" label="User Email" :min-width="25" sortable></el-table-column>
            <el-table-column prop="role" label="Role" sortable :min-width="25"></el-table-column>
            <el-table-column align="right" :min-width="25">
                <template scope="scope">
                    <div style="display: inline-block">
                        <el-button type="info" size="small" @click="userDeleteClick(scope.$index, scope.row)">Remove Access
                            to Zone</el-button>
                        <!--<el-button type="danger" size="small" @click="zoneDeleteClick(scope.$index, scope.row)">Delete</el-button>-->
                    </div>
                </template>
            </el-table-column>
        </el-table>


        <!--Zone management -->
        <el-dialog :title="userDeleteDialog.title" :visible.sync="userDeleteDialog.visible">
            <el-form :model="userDeleteDialog.form" v-loading="userDeleteDialog.loading" @submit.native.prevent>
                <el-form-item label="User Email">
                    <el-input v-model="userDeleteDialog.form.email" type="text" readonly></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 10px">
                    <el-button type="primary" style="margin-top: 10px"
                        @click="userDeleteDialog.visible = false">Cancel</el-button>
                    <el-button type="primary" style="margin-top: 10px" @click="userDeleteDialogClick()">Remove
                        Access</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :title="addUserDialog.title" :visible.sync="addUserDialog.visible">
            <el-form :model="addUserDialog.form" v-loading="addUserDialog.loading" @submit.native.prevent>
                <el-form-item label="User Email">
                    <el-input v-model="addUserDialog.form.email" type="text"></el-input>
                </el-form-item>
                <el-form-item label="Password">
                    <el-input v-model="addUserDialog.form.password" type="password"></el-input>
                </el-form-item>
                <el-form-item label="Role">
                    <el-select v-model="addUserDialog.form.role" placeholder="please select user role">
                        <el-option label="Building Admin" value="buildingAdmin" />
                        <el-option label="Building Admin Advanced" value="buildingAdminAdvanced" />
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-top: 10px">
                    <el-button type="primary" style="margin-top: 10px"
                        @click="addUserDialog.visible = false">Cancel</el-button>
                    <el-button type="primary" style="margin-top: 10px" @click="addUserDialogClick()">Add User</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :title="addExistingUserDialog.title" :visible.sync="addExistingUserDialog.visible">
            <el-form :model="addExistingUserDialog.form" v-loading="addExistingUserDialog.loading" @submit.native.prevent>
                <el-form-item label="User Email">
                    <!-- <el-input v-model="addUserDialog.form.email" type="text"></el-input> -->
                    <el-autocomplete v-model="addExistingUserDialog.form.email" :fetch-suggestions="querySearch" clearable
                        placeholder="Please Input" @select="handleSelect" style="margin-bottom:30px; width: 350px;" />
                </el-form-item>
                <el-form-item style="margin-top: 10px">
                    <el-button type="primary" style="margin-top: 10px"
                        @click="addExistingUserDialog.visible = false">Cancel</el-button>
                    <el-button type="primary" style="margin-top: 10px" @click="addExistingUserDialogClick()">Add Access To
                        Zone</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </section>
</template>
  
<script>
import Axios from "axios"
import UserService from "@/api/user.service"

export default {
    data() {
        return {
            filters: {
                name: ""
            },
            allUsers: [],
            users: ["david.micallef86@gmail.com", "shana.vella@gmail.com"],
            listLoading: false,
            user: this.$session.get("User"),
            userDeleteDialog: {
                title: "Remove User from Zone",
                visible: false,
                loading: false,
                form: {
                    email: "",
                    password: "",
                }
            },
            addUserDialog: {
                title: "Add User",
                visible: false,
                loading: false,
                form: {
                    email: "",
                }
            },
            addExistingUserDialog: {
                title: "Add Existing User",
                visible: false,
                loading: false,
                selected: false,
                users: [],
                usersFiltered: [],
                form: {
                    email: "",
                }
            }
        }
    },
    methods: {
        addExistingUserDialogClick() {
            if (this.addExistingUserDialog.form.email.length > 0 && this.addExistingUserDialog.selected) {
                UserService.addExistingUserToZone(this.addExistingUserDialog.form.email, this.user.activeZone).then(result => {
                    this.addExistingUserDialog.visible = false
                    this.getZoneUsers()
                })

            }
        },
        handleSelect(item) {
            this.addExistingUserDialog.selected = true
        },
        querySearch(queryString, cb) {
            if (queryString.length > 0) {
                this.addExistingUserDialog.usersFiltered = this.addExistingUserDialog.users.filter((user) => user.value.toLowerCase().includes(queryString.toLowerCase()))
            } else {
                this.addExistingUserDialog.usersFiltered = this.addExistingUserDialog.users
            }
            cb(this.addExistingUserDialog.usersFiltered)
        },
        addExistingUserClick() {
            this.addExistingUserDialog.form.email = ""
            this.addExistingUserDialog.visible = true
            this.addExistingUserDialog.selected = false
        },
        addUserClick() {
            this.addUserDialog.form.email = ""
            this.addUserDialog.form.password = ""
            this.addUserDialog.form.role = "buildingAdminAdvanced"
            this.addUserDialog.visible = true
        },
        addUserDialogClick() {
            Axios.all([UserService.addUser(this.addUserDialog.form.email, this.addUserDialog.form.role, this.user.activeZone, this.addUserDialog.form.password)]).then(
                Axios.spread((userAddResponse) => {
                    console.log(userAddResponse)
                    if (userAddResponse.data.result != null && userAddResponse.data.result == "success") {
                        const h = this.$createElement
                        this.$notify({
                            title: "Add User",
                            message: "Success",
                            type: "info"
                        })
                        this.getZoneUsers();
                        this.addUserDialog.visible = false
                    }
                    if (userAddResponse.data.error != null && userAddResponse.data.error == "User already exists") {
                        const h = this.$createElement
                        this.$notify({
                            title: "Add User",
                            message: "Error - User already exists.  Please use the add existing user option",
                            type: "error"
                        })
                        this.addUserDialog.visible = false
                    }
                    if (userAddResponse.data.error != null && userAddResponse.data.error == "Password too weak") {
                        const h = this.$createElement
                        this.$notify({
                            title: "Add User",
                            message: "Error - Password is too weak.  Passwords needs to be a minimum of 8 characters and includes updercase and numbers",
                            type: "error"
                        })
                    }
                }))
        },
        handleRemoveAccessZone(zoneId) {
            console.log(zoneId);
        },
        userDeleteClick(index, row) {
            this.userDeleteDialog.form.email = row.email
            this.userDeleteDialog.visible = true
        },
        userDeleteDialogClick() {
            //Delete the user
            UserService.deleteUserAccessToZone(this.userDeleteDialog.form.email, this.user.activeZone).then((result, err) => {
                if (result.data.error != null) {
                    this.$notify({
                        title: "Add existing user error",
                        message: result.data.error,
                        type: "info"
                    })
                }
                this.userDeleteDialog.visible = false
                this.getZoneUsers()
            })
        },
        userZonesClick(index, row) {
            Axios.all([UserService.getUserZoneAccess(row.email)]).then(
                Axios.spread((userZoneAccessResponse) => {
                    this.userZonesDialog.form.zones = userZoneAccessResponse.data
                }))
            this.userZonesDialog.form.email = row.email
            this.userZonesDialog.visible = true
        },
        handleCurrentChange() { },
        filterUsers() {
            if (this.filters.name.length > 0) {
                this.users = this.allUsers.filter((user) => user.email.toLowerCase().includes(this.filters.name.toLowerCase()))
            } else {
                this.users = this.allUsers
            }
        },
        getZoneUsers() {
            this.listLoading = true
            Axios.all([UserService.getZoneUsers(this.user.activeZone)]).then(
                Axios.spread((zoneUsersResponse) => {
                    this.listLoading = false
                    this.allUsers = zoneUsersResponse.data
                    this.users = zoneUsersResponse.data
                    console.log(zoneUsersResponse)
                    //this.zones = zonesResponse.data
                    this.filterUsers()
                    //Get the users for the auto complete
                    this.getAllUsers()
                })
            )

        },
        getAllUsers() {
            this.addExistingUserDialog.users = []
            Axios.all([UserService.getUsers()]).then(
                Axios.spread((usersResponse) => {

                    usersResponse.data.forEach(user => {
                        if (user.role != 'Administrator') {
                            if (this.allUsers.filter(assignedUser => assignedUser.email == user.email).length == 0) {
                                this.addExistingUserDialog.users.push({
                                    value: user.email
                                })
                            }
                        }
                    });
                })
            )
        }
    },
    mounted() {
        this.getZoneUsers()

    }
}
</script>
  
<style scoped></style>
  


// WEBPACK FOOTER //
// ZoneUsers.vue?8f26258c